
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmBadge as ObiAlarmBadgeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-badge.js';
 
 
 

 
 export const ObiAlarmBadge = createComponent({
   react: React,
   tagName: 'obi-alarm-badge',
   elementClass: ObiAlarmBadgeElement,
   events: {
     
   }
  });
 
 